import React from 'react'
import { ReactComponent } from './product.svg'
import { MergeReactElementProps } from '@komune-io/g2-utils'

interface ProductProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', ProductProps>

export const ProductIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#828282' } = props
    return <ReactComponent fill={color} ref={ref} {...props} />
  }
)
